import axiosInstance from '../axiosInterceptor/axiosInstance'
import selectedOrgId from '../../utils/helpers/selectedOrgId'

const deletePlayer = async (playerId) => {
  const url = `v1/orgs/${selectedOrgId()}/players/${playerId}`
  const response = await axiosInstance.delete(url)
  return response?.data
}

export default deletePlayer
